<template>
  <!-- 天氣資訊 -->

  <div class="row g-2 mb-2">
    <div class="col-12">
      <div class="card card-clean h-100">
        <div class="card-header bg-white border-0 fw-bold text-indigo h5">
          廁間設施與使用狀態
        </div>
        <div class="card-body px-2">
          <div class="tabbed mx-3">
            <input
              type="radio"
              :id="'tab' + i + 'c'"
              name="css-tabs4"
              v-for="(item, i) in organizedData"
              :key="i + 'd'"
              :checked="i === CONST.HUMAN_SENSOR_TYPE.FLOOR[0]"
            />
            <ul class="nav nav-tabs nav-tabs-custom faq-tab-box tabs sm-wrap">
              <li
                class="tab px-0 nav-item flex-fill"
                v-for="(item, i) in organizedData"
                :key="i + 'd'"
              >
                <label
                  class="nav-link py-1 text-center h-100"
                  :for="'tab' + i + 'c'"
                  >{{ i }}</label
                >
              </li>
            </ul>
            <div
              class="tab-content event-area"
              v-for="(item, i) in organizedData"
              :key="i"
            >
              <div class="container my-4">
                <div class="row g-5">
                  <div
                    class="col-4 mb-1"
                    v-for="(genderData, gender) in item"
                    :key="gender"
                  >
                    <div class="text-center row d-flex flex-column">
                      <div class="align-items-center block-3 px-0">
                        <div
                          class="p-2 px-0 block-type rounded-4 rounded-bottom-0 d-flex align-items-center justify-content-evenly"
                        >
                          <div class="py-1">
                            <img
                              :src="genderImg(gender)"
                              alt=""
                              width="50"
                              class="d-block mx-auto"
                            />
                          </div>
                          <div
                            class="text-center d-flex flex-column justify-content-center align-items-center"
                          >
                            <p class="fs-5 my-0 font-weight-bold">可使用</p>
                            <p class="fs-5 my-0 font-weight-bold">Vacant</p>
                          </div>
                          <div class="text-center col-2">
                            <p
                              class="font-weight-bold color-female mb-0 fs-big"
                              :class="genderFontStyle(gender)"
                            >
                              <!-- {剩餘間數} -->
                              {{ genderData.available }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        class="bg-female rounded-bottom-left-4 rounded-bottom-right-4"
                        :class="genderBgStyle(gender)"
                      >
                        <div class="text-white d-flex justify-content-around">
                          <div
                            class="col-6"
                            v-for="(typeData, toiletType) in genderData.types"
                            :key="toiletType"
                          >
                            <div class="d-flex align-items-center block-1">
                              <img
                                :src="toiletTypeImg(toiletType)"
                                alt=""
                                :height="toiletTypeImgHeight(toiletType)"
                                class="mx-auto d-block shadow-img"
                              />
                            </div>
                            <div class="text-center text-white">
                              <p class="fs-2 font-weight-bold text-white">
                                {{ typeData.available }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-4 mb-1">
                    <div class="text-center row d-flex flex-column">
                      <div class="align-items-center block-3 px-0">
                        <div
                          class="p-2 px-0 block-type rounded-4 rounded-bottom-0 d-flex align-items-center justify-content-evenly"
                        >
                          <div class="py-1">
                            <img
                              src="@/assets/img/toilet_male.png"
                              alt=""
                              width="50"
                              class="d-block mx-auto"
                            />
                          </div>
                          <div
                            class="text-center d-flex flex-column justify-content-center align-items-center"
                          >
                            <p class="fs-5 my-0 font-weight-bold">可使用</p>
                            <p class="fs-5 my-0 font-weight-bold">Vacant</p>
                          </div>
                          <div class="text-center col-2">
                            <p class="fs-2 font-weight-bold color-male mb-0">
                        
                              3
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        class="bg-male rounded-bottom-left-4 rounded-bottom-right-4"
                      >
                        <div class="text-white d-flex justify-content-around">
                          <div class="col-6">
                            <div class="d-flex align-items-center block-1">
                              <img
                                src="@/assets/img/toilet_squat.svg"
                                alt=""
                                height="20"
                                class="mx-auto d-block shadow-img"
                              />
                            </div>
                            <div class="text-center text-white">
                              <p class="fs-4 font-weight-bold text-white">
                                {3}
                              </p>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="d-flex align-items-center block-1">
                              <img
                                src="@/assets/img/toilet_sit.svg"
                                alt=""
                                height="38"
                                class="mx-auto d-block shadow-img"
                              />
                            </div>
                            <div class="text-center text-white">
                              <p class="fs-4 font-weight-bold text-white">
                                {4}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 mb-1">
                    <div class="text-center row d-flex flex-column">
                      <div class="align-items-center block-3 px-0">
                        <div
                          class="p-2 px-0 block-type rounded-4 rounded-bottom-0 d-flex align-items-center justify-content-evenly"
                        >
                          <div class="py-1">
                            <img
                              src="@/assets/img/toilet_family.png"
                              alt=""
                              width="50"
                              class="d-block mx-auto"
                            />
                          </div>
                          <div
                            class="text-center d-flex flex-column justify-content-center align-items-center"
                          >
                            <p class="fs-5 my-0 font-weight-bold">可使用</p>
                            <p class="fs-5 my-0 font-weight-bold">Vacant</p>
                          </div>
                          <div class="text-center col-2">
                            <p
                              class="fs-2 font-weight-bold color-accessible mb-0"
                            >
                           
                              3
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        class="bg-accessible rounded-bottom-left-4 rounded-bottom-right-4"
                      >
                        <div class="text-white d-flex justify-content-around">
                          <div class="col-6">
                            <div class="d-flex align-items-center block-1">
                              <img
                                src="@/assets/img/toilet_squat.svg"
                                alt=""
                                height="20"
                                class="mx-auto d-block shadow-img"
                              />
                            </div>
                            <div class="text-center text-white">
                              <p class="fs-4 font-weight-bold text-white">
                                {3}
                              </p>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="d-flex align-items-center block-1">
                              <img
                                src="@/assets/img/toilet_sit.svg"
                                alt=""
                                height="38"
                                class="mx-auto d-block shadow-img"
                              />
                            </div>
                            <div class="text-center text-white">
                              <p class="fs-4 font-weight-bold text-white">
                                {4}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="chart-description chart-description-btm mt-8">
            廁間馬桶資訊為都歷園區大停車場男廁、女廁及無障礙廁間資訊。
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
import moment from "moment";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
import humanSensor from "../../store/modules/eastCoastDataApi/humanSensor";

export default {
  components: {},
  props: {
    selectedScenicAreaId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      CONST: CONST,
      selectedFloor: 0,
      floorList: ["1F", "2F"],
      // floorList:{
      //   0:"1F",
      //   1:"2F",
      // },
      scienicDisastersData: [],
      testHumanSensorData: [
        {
          floor: "1F",
          gender: "male",
          inUse: false,
          toiletType: "sit",
          identifierSetting: "DE12",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00001",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "female",
          inUse: false,
          toiletType: "sit",
          identifierSetting: "DE14",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "阿美民俗中心女廁",
          publicPlaceId: 178,
          deviceId: "hm00003",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "mixed",
          inUse: false,
          toiletType: "sit",
          identifierSetting: "DE13",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "阿美民俗中心親子廁",
          publicPlaceId: 21,
          deviceId: "hm00004",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "male",
          inUse: false,
          toiletType: "squat",
          identifierSetting: "DE15",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00005",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "male",
          inUse: false,
          toiletType: "squat",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "male",
          inUse: true,
          toiletType: "squat",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "male",
          inUse: true,
          toiletType: "squat",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "female",
          inUse: true,
          toiletType: "squat",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場女廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "female",
          inUse: true,
          toiletType: "sit",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場女廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
      ],
      organizedData: [],
    };
  },
  created() {},
  methods: {
    test(item, i) {
      console.log("item", item);
      console.log("i", i);
    },

    async getHumanSensor() {
      const condition = {
        areaId: 0,
      };
      await this.$store.dispatch("humanSensor/getHumanSensor", condition);
    },

    genderImg(type) {
      if (type === "male" || type === "female") {
        return require(`@/assets/img/toilet_${type}.png`);
      } else {
        return require(`@/assets/img/toilet_family1.png`);
      }
    },

    toiletTypeImg(type) {
      return require(`@/assets/img/toilet_${type}.svg`);
    },

    toiletTypeImgHeight(type) {
      if (type === "squat") {
        return 20;
      } else if (type === "sit") {
        return 38;
      }
    },

    genderFontStyle(type) {
      return `color-${type}`;
    },

    genderBgStyle(type) {
      return `bg-${type}`;
    },

    //取得humanSensor並按照廁所種類重組data
    organizeToilets(data) {
      const result = {};

      data.forEach((item) => {
        const floor = item.floor;
        const gender = [
          CONST.HUMAN_SENSOR_TYPE.GENDER_FEMALE,
          CONST.HUMAN_SENSOR_TYPE.GENDER_MALE,
        ].includes(item.gender)
          ? item.gender
          : CONST.HUMAN_SENSOR_TYPE.GENDER_OTHER;
        const toiletType = item.toiletType;

        // 初始化樓層
        if (!result[floor]) {
          result[floor] = {};
        }

        // 初始化性別層
        if (!result[floor][gender]) {
          result[floor][gender] = {
            total: 0,
            inUse: 0,
            available: 0,
            types: {},
          };
        }

        // 初始化馬桶類型層
        if (!result[floor][gender].types[toiletType]) {
          result[floor][gender].types[toiletType] = {
            total: 0,
            inUse: 0,
            available: 0,
            list: [],
          };
        }

        // 加入設備到 list
        result[floor][gender].types[toiletType].list.push(item);

        // 累加統計
        result[floor][gender].total += 1;
        result[floor][gender].types[toiletType].total += 1;

        if (item.inUse) {
          result[floor][gender].inUse += 1;
          result[floor][gender].types[toiletType].inUse += 1;
        }
      });

      // 統計 available 數據
      for (const floor in result) {
        for (const gender in result[floor]) {
          const genderData = result[floor][gender];
          genderData.available = genderData.total - genderData.inUse;

          for (const toiletType in genderData.types) {
            const typeData = genderData.types[toiletType];
            typeData.available = typeData.total - typeData.inUse;
          }
        }
      }
      console.log("result", result);
      this.organizedData = result;
      // return result;
    },
  },
  computed: {
    ...mapGetters("humanSensor", { humanSensor: "getHumanSensorData" }),
  },

  watch: {
    selectedScenicAreaId: {
      async handler(newVal) {
        if (newVal === null) return;
        console.log("newVal >0", newVal);
      },
      immediate: true,
    },

    humanSensor: {
      async handler(newVal) {
        console.log("humanSensor", newVal);
      },
    },

    // testHumanSensorData:{
    //   async handler(newVal) {
    //    this.organizeToilets(newVal);
    //     // console.log("organizedData", organizedData);
    //   },
    // }
  },
  async mounted() {
    this.getHumanSensor();
    this.organizeToilets(this.testHumanSensorData);
  },
};
</script>

<style lang="scss" scoped>
$max: 20;
@for $i from 0 through $max {
  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tabs
    .tab:nth-of-type(#{$i})
    label {
    background: #00ae9a !important;
    color: #fff;
  }

  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tabs
    .tab:nth-of-type(#{$i})
    label:after {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@for $i from 0 through $max {
  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tab-content:nth-of-type(#{$i}) {
    display: block;
    box-shadow: none;
  }
}

.nav-tabs li .nav-link:hover {
  background-color: #00ae9a;
  color: #fff;
  border-bottom: 0.8px solid #eee;
  border-top: 0.8px solid #eee;

  // border:1px !important;
}

.block-type {
  border-radius: 10px;
  background-color: #ededed;

  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #f2f2f2;

  // min-width: 100px;
}
// .block-3 div:nth-child(5) > div > b {
//   font-size: 14px !important;
//   line-height: 40px;
// }

.event-area {
  // 陰影

  // border:1px  solid #aaaaaad5;
  // height: 16rem;
  // min-height: 16rem;
  // max-height: 16rem;

  // overflow-y: scroll;
  // overflow-x: scroll;
}

.fs-big{
  font-size:3rem;
}

.g-6 {
  gap: 1.75rem !important;
}
.block-1 {
  // width:45px;
  height: 70px;
}
</style>
